import { Component, OnInit } from '@angular/core';
import { AppFilter, ConfirmModal } from 'src/modules/shared';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { FinanceService } from 'src/modules/features/contractor/services';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AuthenticationService } from 'src/modules/core/services';
@Component({
  selector: 'app-pay-Ncc',
  templateUrl: './pay-Ncc.component.html',
  styleUrls: ['./pay-Ncc.component.scss'],
})
export class PayNccComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  totalItems: number = 5;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  arrangements: Array<any> = [];
  error: any;
  collapsePaymentStatus: boolean = true;
  paymentIRR;
  errorMsg;
  successMsg;
  paymentField = new FormControl('', Validators.required);
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private location: Location,
    private modalService: SuiModalService,
    private financeSvc: FinanceService,
    private auth: AuthenticationService
  ) {
    this.getArrangement();

    this.route.queryParams.subscribe((params) => {
      console.log(params, 'params');
      if (params['status'] == 'true') {
        this.successMsg = params['message'];
      }
      if (params['status'] == 'false') {
        this.errorMsg = params['message'];
      }
      // route to contractor page if user is signed in

      const user = this.auth.userValue;
      if (
        user &&
        user.organizationId.organizationTypeId.organizationTypeId ==
          'contractor'
      ) {
        this.router.navigate(['/contractor/payment/list'], {
          queryParams: {
            status: params['status'],
            message: params['message'],
          },
        });
      }
    });
  }
  goBack() {}

  pay(arr) {
    this.financeSvc.payment = arr;
    this.router.navigate(
      [`/home-page/pay/pay-service/${arr.revenueService.revenueServiceId}`],
      {
        queryParams: {
          amount: arr['revenueService']['amount'],
          allowPartPayment: arr['revenueService']['allowPartPayment'],
          revenueServiceId: arr['revenueService']['revenueServiceId'],
          requireInvoiceNo: arr['revenueService']['requireInvoiceNo'],
          purpose: arr['revenueService']['categoryName'],
        },
      }
    );
  }
  findService(arr, id) {
    for (let i = 0; i < arr.length; i++) {
      let service = arr[i];
      if (service.revenueService.revenueServiceId == id) {
        return service.revenueService.categoryName;
      }
      if (service.children) {
        this.findService(service.children, id);
      }
    }
  }
  goToPayment(payment) {
    console.log(payment, 'payment');
    this.router.navigate(['/home-page/pay/instruction'], {
      queryParams: {
        purpose: this.findService(
          this.arrangements,
          payment.payment.paymentDetails.revenue_service_id
        ),
        beneficiary: 'Nigerian Communications Commision',
        amount: payment['amount'],
        rrr: payment.payment['transactionRef'],
        paymentLink: payment['paymentUrl'],
        address: payment['payment']['paymentDetails']['payers_address'],
        description:
          payment['payment']['paymentDetails']['description'] === null
            ? payment['payment']['paymentDetails']['invoice_description']
            : payment['payment']['paymentDetails']['description'],
        companyName: payment['payment']['paymentDetails']['company_name'],
        currencyCode: payment['currencyCode'],
        docPath: payment['payment']['detailsDocumentPath'],
        name: payment['payment']['paymentDetails']['payers_name'],
        phone: payment['payment']['paymentDetails']['payers_phone'],
        email: payment['payment']['paymentDetails']['payers_email'],
        internalTransactionRef: payment['payment']['internalTransactionRef'],
        paymentType:
          payment['payment']['paymentDetails']['currencyId'] == 'naira'
            ? 'LOCAL'
            : 'FOREIGN',
      },
    });
  }
  getArrangement() {
    this.pending = true;
    this.financeSvc.getArrangement({ params: {} }).subscribe(
      (res: any) => {
        this.pending = false;
        this.arrangements = res;
      },
      (error) => {
        this.pending = false;
        this.error = error.error.errorMessage
          ? error.error.errorMessage
          : error.error
          ? error.error
          : error;
      }
    );
  }

  submit() {
    if (this.paymentField.valid) {
      this.pending = true;
      this.financeSvc
        .getPaymentStatus({ id: this.paymentField.value })
        .subscribe(
          (res) => {
            this.pending = false;
            this.paymentIRR = res;
          },
          (error) => {
            this.pending = false;
            this.errorMsg = this.error = error.message ? error.message : error;
            // ;
          }
        );
    } else {
    }
  }

  searchRecords(event) {}
  displayRecords(event) {}
  sortRecords(event) {}
  nextPage(event) {}
  viewProject(event) {}
  ngOnInit(): void {}
}
